module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-7.21132406.png";